import { useEffect } from "react";

interface UseWindowBeforeUnloadOptions {
  enabled?: boolean;
}

/**
 * 页面拦截保护
 * @param enabled 是否启用
 * @returns 
 */
export const useWindowBeforeUnload = ({ enabled = true }: UseWindowBeforeUnloadOptions = {}) => {
  useEffect(() => {
    if (!enabled || typeof window === "undefined") return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled]);
};
